import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propShape } from '../../../../helpers/custom-prop-types';
import PlainInput from '../../Common/PlainInput';
const ZipCodeFields = (props) => {
    const { zipCode1, zipCode2 } = props;
    return (_jsxs("div", { children: [_jsx(PlainInput, { className: 'input-form-text is-onethird', input: zipCode1.input, maxLength: 3, meta: zipCode1.meta, placeholder: '000', type: 'tel' }), _jsx(PlainInput, { className: 'input-form-text is-onethird', input: zipCode2.input, maxLength: 4, meta: zipCode2.meta, placeholder: '0000', type: 'tel' })] }));
};
ZipCodeFields.propTypes = {
    zipCode1: propShape().isRequired,
    zipCode2: propShape().isRequired,
};
export default ZipCodeFields;
